import ReactMarkdown, { type Components } from "react-markdown";

// Report body renderer. Markdown paragraphs carry their own spacing, so no
// `whitespace-pre-wrap` here — combined with markdown it doubled every blank line
// into a tall gap (the first client reports looked like scattered sentences).
const components: Components = {
  h2: ({ children }) => <h2 className="mb-2 mt-4 text-base font-semibold first:mt-0">{children}</h2>,
  h3: ({ children }) => <h3 className="mb-1 mt-3 text-sm font-semibold first:mt-0">{children}</h3>,
  p: ({ children }) => <p className="mb-3 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="mb-3 list-disc pl-5">{children}</ul>,
  ol: ({ children }) => <ol className="mb-3 list-decimal pl-5">{children}</ol>,
  li: ({ children }) => <li className="mb-1">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
};

export const ReportMarkdown = ({ children }: { children: string }) => (
  <ReactMarkdown components={components}>{children}</ReactMarkdown>
);
